const SELECTORS = {
	input: '.input-counter',
	countLength: '#countLength',
	countDownDisabled: '.count-down-disabled',
};

const CLASSES = {
	disabled: 'disabled',
};

export class InputCounter {
	constructor() {
		this.input = document.querySelector(SELECTORS.input);
		this.countLength = document.querySelector(SELECTORS.countLength);

		const requiredElements = [this.input, this.countLength];

		if (requiredElements.some((el) => !el)) {
			return;
		}

		this.bindEvents();
		this.setup();
	}

	static init() {
		// eslint-disable-next-line
		const inputCounter = new InputCounter();
	}

	bindEvents() {
		['calculateLength'].forEach((e) => {
			this[e] = this[e].bind(this);
		});
	}

	// calculate current len
	calculateLength(e) {
		const currentLength = parseInt(e.target.value.length, 10);

		this.countLength.textContent = `${currentLength}`;

		const countDownButton = document.querySelector(SELECTORS.countDownDisabled);

		if (!countDownButton) return;

		if (countDownButton && currentLength > 3) {
			countDownButton.classList.remove(CLASSES.disabled);
		} else if (countDownButton && currentLength <= 3) {
			countDownButton.classList.add(CLASSES.disabled);
		}
	}

	setupEventListeners() {
		this.input.addEventListener('input', this.calculateLength);
	}

	initialySetupLength(val) {
		this.countLength.textContent = `${val.length}`;
	}

	setup() {
		this.setupEventListeners();
		this.initialySetupLength(this.input.value);
	}
}
